var environments = {
  cartApi: {
    local: 'http://localhost:8081',
    dev: 'https://cartapi.dev-prsn.com',
    qa: 'https://cartapi-qaint.dev-prsn.com',
    stg: 'https://cartapi.stg-prsn.com',
    prd: 'https://cartapi.prd-prsn.com',
    perf: 'https://cartapi-perf.stg-prsn.com'
  }
};
export default environments;